export default {
  text: {
    'font-size': '14px'
  }
};
